var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sendPointsToGeocoding"}},[_c('el-row',[_c('el-col',[_c('Title',{attrs:{"title":"Enviar puntos a geocoding","subtitle":"Busca las ordenes y envia a geocoding."}})],1),_c('el-col',[_c('TableSPTG',{model:{value:(_vm.list),callback:function ($$v) {_vm.list=$$v},expression:"list"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }